module.exports = __webpack_public_path__ + "img/vuejs-white.315d513d.png";